import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { MetaLabel } from './MetaLabel';
interface LightboxProps {
  open: boolean;
  image?: string;
  title?: string;
  camera?: string;
  onClose: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function Lightbox({
  open,
  image,
  title,
  camera,
  onClose
}: LightboxProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-37" data-mp="6185krpuof2k">
      {open && image ? <motion.div role="dialog" aria-modal="true" aria-label={`${title ?? 'Reference'} reference frame`} className="absolute inset-0 z-40 flex flex-col justify-center bg-ink/95 px-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: EASE
    }} onClick={onClose} data-id="element-38" data-mp="5zx4x0rpbnfo">
          <motion.figure className="mx-auto w-full max-w-pane" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: EASE
      }} data-id="element-39" data-mp="1z9jnwi0y7zjx">
            <img src={image} alt={`Reference frame — ${title ?? ''}`} className="w-full" data-id="element-40" data-mp="2mzx51dhzwdzq" />
            <figcaption className="mt-4 flex items-baseline justify-between border-t border-line pt-3" data-id="element-41" data-mp="2i2nh62a98ae0">
              <span className="font-display text-lg font-semibold tracking-display text-fg" data-id="element-42" data-mp="2dy7dm7o45f1y">{title}</span>
              <MetaLabel tone="dim" data-id="element-43" data-mp="2905ytyxq01wa">{camera}</MetaLabel>
            </figcaption>
          </motion.figure>
          <button type="button" onClick={onClose} aria-label="Close reference frame" className="absolute right-4 top-4 flex h-12 w-12 items-center justify-center border border-line text-fg focus:outline-none focus-visible:ring-1 focus-visible:ring-fg" data-id="element-44" data-mp="12lwvqwawr3ca">
            <XIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-45" data-mp="13zodhhguvgud" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}